
import {TNS3ND_CONTEXT,getTnsSdkScriptSrc,parseURL, isEnableCdn} from "../utils/loadResources";
import {debugLog} from "../utils/loadResources";
import {getCurrHost, getCurrUrl} from './load3nd';

function getUa() {
    var ua = navigator.userAgent.toLowerCase();
    return ua;
}


/**
 * 获取浏览器类型
 * @returns 返回  Opera/FF/Chrome/Safari/Edge/IE
 */
export const getBrowser = ()=> {
  const userAgent = navigator.userAgent;
  let browserType = '';
  if (userAgent.indexOf('Opera') > -1) {
    browserType = 'Opera';
  } else if (userAgent.indexOf('Firefox') > -1) {
    browserType = 'FF';
  } else if (/Edg/i.test(navigator.userAgent)) {
    browserType = 'Edge';
  } else if (userAgent.indexOf('Chrome') > -1) {
    browserType = 'Chrome';
  } else if (userAgent.indexOf('Safari') > -1) {
    browserType = 'Safari';
  } else if (!!(window ).ActiveXObject || 'ActiveXObject' in window) {
    browserType = 'IE';
  }
  return browserType;
};

export function isLoadPolyfill() {
    var ua = getUa();
    var browserType = getBrowser();
    if (ua.indexOf('msie') > -1 && parseInt(ua.match(/msie\s+([\d\.]+)/i)[1]) < 10) {
        return true;
    } else if (getBrowser() == 'IE' && parseInt(navigator.userAgent.match(/trident\/[\d]+\.[\d]+/i)[0].split('/')[1]) < 6) {
        return true;
    } else if(browserType === "Chrome" && parseInt(ua.match(/chrome\/[\d]+\.[\d]+/i)[0].split('/')[1]) < 90){
        return true;
   }else if(browserType === "Safari" ){
        const matched = ua.match(/version\/[\d]+\.[\d]+/i);
        const version = matched && parseInt(matched[0].split('/')[1]);
        return version && version < 11;
    }
}

function loadPolyfill() {
    const isloadPolyfill = isLoadPolyfill();

    if(!isloadPolyfill){
        debugLog("[TNE]当前浏览器版本无需加载polyfill");
        return;
    }
    var currUrl = getCurrUrl();
    // console.log("AAA---currUrl tns3nd:"+currUrl);
    var urlInfo = parseURL(currUrl);
    var tns3nd = urlInfo.params.tns3nd; //默认加载tns3nd.js资源，如需禁用设置false
    var same = urlInfo.params.same; //是否保持同源

    var tns3ndContext = '/iuap-tns/ucf-wh/share/';
    var tns3ndSubDir= 'static/polyfill';
    var tns3ndFileName = 'tne3rd_polyfill_full.d409a644.js';
    var scriptSrc = tns3ndContext+tns3ndSubDir+"/"+tns3ndFileName;
    if(same){//按同源域名策略加载
        var tns3ndHost = currUrl.replace(/#.*$/, "").replace(/\?.*$/, "").replace(/\/[^\/]+$/, "/").replace("/runtime/","/".concat(tns3ndSubDir));
        // 当前tnsSdk.js走cdn域名，则不需要替换三方包路径
        if(!isEnableCdn()){
            scriptSrc = tns3ndHost+"/"+tns3ndFileName;
        }
    }
    if(!document){
        console.error('[TNE]动态加载polyfill异常，document元素不存在');
        return;
    }
    var script = document.createElement('script');
    script.type = 'text/javascript';
    // script.async = true;
    script.onerror = function () {
        console.error('[TNE]动态加载polyfill异常');
    };
    script.onload = script.onreadystatechange = function () {
        if(!script.readyState||script.readyState==='loaded'||script.readyState==='complete'){
            debugLog('[TNE]动态加载polyfill完成');
            // callback && eval(callback+'()')
        }
        script.onload = script.onreadystatechange=null
    };
    script.src = scriptSrc;
    debugLog("[TNE]动态加载polyfill中");
     //html文件中的script标签src属性所引用的js文件的代码内再使用document.write()方式引入的js文件是同步执行的
        var loadedFuncStr =
            "javascript:console.log('[TNE]动态加载polyfill完成');" 
        document.write
            ? document.write(
                  '<script type="text/javascript" src="' +
                      scriptSrc +
                      '" onload="' +
                      loadedFuncStr +
                      '"></script>'
              )
            : console.error("[TNE]动态加载polyfill异常，document.write 不存在");
}
loadPolyfill()